import { KendoBaseComponent } from '@progress/kendo-base-components-vue-wrapper'
import ButtonProps from './ButtonProps'


export default {
    template: '<button><slot></slot></button>',
    props: ButtonProps,
    mixins: [
        KendoBaseComponent
    ],
    mounted() {
        kendo.jQuery(this.$el).kendoButton(this.widgetOptions)

        this.$emit('kendowidgetready', this.kendoWidget())
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoButton()
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-buttons-vue-wrapper/src/KendoButton/KendoButtonMixin.js